import { cn } from '~/lib/utils';

const CONTENT_WIDTH = {
  narrow: 'max-w-[400px]',
  wide: 'max-w-[500px]',
} as const;

interface CenteredAuthLayoutProps extends React.ComponentProps<'div'> {
  /** Caps the content column; omit for content that sizes itself, like a spinner. */
  contentWidth?: keyof typeof CONTENT_WIDTH;
  /** Props for the content column, e.g. a data-testid. */
  contentProps?: React.ComponentProps<'div'> & { 'data-testid'?: string };
}

/**
 * A full-screen column that centers one auth step, such as magic-link
 * verification or an auth error, both ways in the window.
 */
export function CenteredAuthLayout({
  contentWidth,
  contentProps,
  className,
  children,
  ...props
}: CenteredAuthLayoutProps) {
  return (
    <div
      className={cn(
        'mx-auto flex min-h-screen max-w-[600px] items-center justify-center px-4',
        className
      )}
      {...props}
    >
      {contentWidth ? (
        <div
          {...contentProps}
          className={cn('w-full', CONTENT_WIDTH[contentWidth], contentProps?.className)}
        >
          {children}
        </div>
      ) : (
        children
      )}
    </div>
  );
}
